import z from "zod";
import { locationSelectOptionSchema } from "view/locations/utils/location.schema";
import { PushingTugPlanningErrorType } from "./PushingTugPlanningUtils";

const PushedBargePlanningCallFormSchema = z.object({
	id: z.number().gt(0),
	pta: z.number().nullish(),
	ptd: z.number().nullish(),
	location: locationSelectOptionSchema,
});

export const PushedBargePlanningSchema = z.object({
	voyages: z.array(z.object({
		callLinks: z.array(z.object({
			pushedBargeCall: PushedBargePlanningCallFormSchema.nullable(),
			pushingTugCall: PushedBargePlanningCallFormSchema,
		}).refine(
			(value) => value.pushedBargeCall === null || value.pushedBargeCall.location.id === value.pushingTugCall.location.id, {
				message: PushingTugPlanningErrorType.MISMATCHING_LOCATION,
			},
		)),
	})),
});

export type PushedBargePlanningSchemaInput = z.input<typeof PushedBargePlanningSchema>;
export type PushedBargePlanningSchemaOutput = z.output<typeof PushedBargePlanningSchema>;

